/**
 * Code will also used from massmailer. See sub-massenmailer.js
 */

$(window).on('grid-page-load-finish', function (event) {
    var widgetContainer = $(event.state).closest('div[widget="esearcher.grid_gridHeader"]');
    if (widgetContainer.data('name')  === 'add-appointment-to-doc-table') {
        // use trigger only for called by grid with data-name "add-appointment-to-doc-table"
        handleStorageOfCheckboxValues();
    }
});
$(document).on('DOMContentLoaded', function () {
    $('#selectAppointmentFormSendAppointment').on('ifChanged', function () {
        $('#collapseAppointment').slideToggle();
    });
});

/**
 * function will be called every sortable table draw
 *
 * stores appointment IDs into hidden field on check a checkbox an load checkbox state if grid is rebuild
 */
function handleStorageOfCheckboxValues() {
    var selectedAppointmentsField = $('#selectAppointmentFormSelectedAppointments');
    if (selectedAppointmentsField.length === 1) {
        // read values from hidden field
        var selectedAppointments = selectedAppointmentsField.val().split(',');
        $(selectedAppointments).each(function (key, id) {
            // change checkbox state to selected for each id from hidden field.
            $('.selectAppointment[data-appointment-id="' + id + '"]').prop('checked', true);
        });
        // initializes iCheck
        $('.selectAppointment:checkbox').iCheck({
            checkboxClass: 'checkbox-square',
            radioClass: 'radio-square',
            increaseArea: '20%'
        });

        $('.selectAppointment').on('ifChanged', function () { // if checkbox state was changed...

            if ($(this).prop('checked')) {
                // use toString(), because after read with val().split(','), all entries are strings
                selectedAppointments.push($(this).data('appointmentId').toString());
            } else {
                // remove entry if it was unchecked
                var index = selectedAppointments.indexOf($(this).data('appointmentId').toString());
                if (index > -1) {
                    selectedAppointments.splice(index, 1);
                }
            }
            selectedAppointmentsField.val(selectedAppointments.toString()); // restore temp array into hidden field.

            // hook to get appointment ID on change ((un)check) checkbox state
            $(window).trigger({
                type: 'calender-appointment-selected',
                appointmentId: $(this).data('appointmentId'),
                checked: $(this).prop('checked')
            });
        });
    }
}